import * as React from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __ } from '@bart.sk-eshop/react-i18n';
import { setSidebarCategoriesShow } from '../../../../containers/App/actions';

interface Props {
  sidebarCategoriesVisible?: boolean;
  sidebarCategoriesShow?: boolean;
  dispatch: any;
}

const Button = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${rem(8)};
  width: ${rem(224)};
  height: ${rem(40)};
  flex: 0 0 auto;
  padding: ${rem(8)} ${rem(24)};
  border: none;
  border-radius: ${rem(999)};
  cursor: pointer;
  font-family: inherit;
  font-weight: 600;
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  color: #171717;
  ${({ active, theme }) =>
    active
      ? css`
          background: #ebebeb;
          &:hover {
            background: #e0e0e0;
          }
        `
      : css`
          background: ${theme.color.secondary};
          &:hover {
            background: ${theme.color.secondaryLighter};
          }
        `}

  /* In the in-between range (992–1450px) the toggle shrinks to fit its narrower
     column (HeaderNew BottomBar), freeing horizontal room for the main menu.
     The label wraps to two lines ("Zobraziť" / "kategórie"), so the column can
     be even narrower. Its width is driven by the HeaderLeft column (see
     HeaderNew BottomBar). */
  @media (min-width: 992px) and (max-width: 1450px) {
    width: 100%;
    min-width: 0;
    height: auto;
    min-height: ${rem(40)};
    padding: ${rem(4)} ${rem(8)};
    font-size: ${rem(11)};
    line-height: ${rem(14)};
    gap: ${rem(4)};
    text-align: center;
  }
`;

const Chevron = styled.svg<{ up: boolean }>`
  width: ${rem(20)};
  height: ${rem(20)};
  flex: 0 0 auto;
  ${({ up }) => up && 'transform: rotate(180deg);'}

  @media (min-width: 992px) and (max-width: 1450px) {
    width: ${rem(12)};
    height: ${rem(12)};
  }
`;

const CategoriesToggleButton: React.FC<Props> = ({
  sidebarCategoriesVisible,
  sidebarCategoriesShow,
  dispatch,
}) => {
  if (!sidebarCategoriesVisible) {
    return null;
  }
  const show = !!sidebarCategoriesShow;
  return (
    <Button
      type="button"
      active={show}
      onClick={() => dispatch(setSidebarCategoriesShow(!show))}
    >
      {show ? __('Skryť kategórie') : __('Zobraziť kategórie')}
      <Chevron
        up={show}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 9l6 6 6-6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Chevron>
    </Button>
  );
};

const mapStateToProps = (state) => ({
  sidebarCategoriesVisible: state.general.sidebarCategoriesVisible,
  sidebarCategoriesShow: state.general.sidebarCategoriesShow,
});

export default connect(mapStateToProps)(CategoriesToggleButton);
